const data = [
    {
        title: "Copenhagen",
        location: "Denmark",
        googleMapsUrl: "https://goo.gl/maps/1DGM5WrWnATgkSNB8",
        startDate: "11 Aug, 2022",
        endDate: "21 Aug, 2021",
        description: "Copenhagen is the capital and most populous city of Denmark, with a population of approximately 660,000 in the municipality and 1.4 million in the urban area. The city is situated on the islands of Zealand and Amager, separated from Malmö, Sweden, by the Øresund strait. The Øresund Bridge connects the two cities by rail and road",
        imageUrl: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/28/74/c2/dc/caption.jpg?w=1400&h=1400&s=1"
    },
    {
        title: "Abuja",
        location: "Nigeria",
        googleMapsUrl: "https://maps.app.goo.gl/fCKafht7RZcwktH29",
        description: "Abuja is the capital and eighth most populous city of Nigeria. It replaced Lagos, the country's most populous city, as the capital on 12 December 1991. Abuja's geography is defined by Aso Rock, a 400-metre (1,300 ft) monolith left by water erosion. The Presidential Complex, National Assembly, Supreme Court and much of the city extend to the south of the rock.",
        imageUrl: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/18/4b/63/d4/the-magnificent-zuma.jpg?w=300&h=-1&s=1"
    },
    {
        title: "Cross-River",
        location: "Nigeria",
        googleMapsUrl: "https://maps.app.goo.gl/hq3F94BiquX3TEGt7",
        description: "Cross River State is a state in the South-South geopolitical zone of Nigeria. Named for the Cross River, the state was formed from the eastern part of the Eastern Region on 27 May 1967. Its capital is Calabar, it borders to the north through Benue state, to the west through Ebonyi state and Abia state, and to the southwest through Akwa Ibom state, while its eastern border forms part of the national border with Cameroon.",
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/7/70/Kwafalls.jpg"
    },
    {
        title: "Pennsylvania",
        location: "United States",
        googleMapsUrl: "https://maps.app.goo.gl/xBts2GVNC5X3Wckd8",
        startDate: "8 Aug, 2019",
        endDate: "22 May, 2023",
        description: "Pennsylvania is a landlocked state spanning the Mid-Atlantic, Northeastern, Appalachian, and Great Lakes regions of the United States. Pennsylvania borders Delaware to its southeast, Maryland to its south, West Virginia to its southwest, Ohio and the Ohio River to its west, Lake Erie and New York to its north, the Delaware River and New Jersey to its east, and the Canadian province of Ontario to its northwest.",
        imageUrl: "https://media.istockphoto.com/id/1590744588/photo/red-car-of-duquesne-incline-with-pittsburgh-downtown-panorama-on-background-at-sunset.jpg?s=612x612&w=0&k=20&c=YxmZiJCAOwg07QKVCWLWx3Mj6EVBzRtmcAfrxILdBI0="
    },
    {
        title: "New York",
        location: "United States",
        googleMapsUrl: "https://maps.app.goo.gl/REjqriQ82EYLv2Qp9",
        startDate: "2020",
        endDate: "Present",
        description: "New York City comprises 5 boroughs sitting where the Hudson River meets the Atlantic Ocean. At its core is Manhattan, a densely populated borough that’s among the world’s major commercial, financial and cultural centers. Its iconic sites include skyscrapers such as the Empire State Building and sprawling Central Park. Broadway theater is staged in neon-lit Times Square",
        imageUrl: "https://cdn.britannica.com/31/94231-050-C6B60B89/Statue-of-Liberty-Island-Upper-New-York.jpg"
    }
]

export default data